/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_Passengers_ValInputs */

const es_cap_jpc_passengers_val = /** @type {(inputs: Cap_Jpc_Passengers_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 personas`)
};

const gl_cap_jpc_passengers_val = /** @type {(inputs: Cap_Jpc_Passengers_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 persoas`)
};

const en_cap_jpc_passengers_val = /** @type {(inputs: Cap_Jpc_Passengers_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 guests`)
};

/**
* | output |
* | --- |
* | "6 guests" |
*
* @param {Cap_Jpc_Passengers_ValInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_passengers_val = /** @type {((inputs?: Cap_Jpc_Passengers_ValInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_Passengers_ValInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_passengers_val(inputs)
	if (locale === "en") return en_cap_jpc_passengers_val(inputs)
	return es_cap_jpc_passengers_val(inputs)
});